<template>
  <div>
    <CDialog>
      <h3 slot="title" class="heading-lined">{{ $t("user_menu.sign_in") }}</h3>
      <div v-if="message.content.length > 0" :class="messageClass">
        {{ message.content }}
      </div>
      <p v-html="$t('sign_in_dialog.p')"></p>
      <div slot="actions">
        <div class="email-row">
          <ButtonCointracker
            :text="this.$t('sign_in_dialog.button.email')"
            icon-class="fa fa-envelope mr-2"
            @click="goToEmailLogin"
          />
          <ButtonCointracker
            :text="this.$t('register_page.register')"
            icon-class="fa fa-user-plus mr-2"
            @click="goToEmailRegister"
          />
        </div>
        <ButtonSignInGoogle
          :disabled="loginRequestInProcess"
          @click="signIn('google')"
        />
        <ButtonSignInTwitter
          :disabled="loginRequestInProcess"
          @click="signIn('twitter')"
        />
        <ButtonSignInFacebook
          :disabled="loginRequestInProcess"
          @click="signIn('facebook')"
        />

        <CButton
          class="btn btn-secondary btn-block mt-5"
          :text="this.$t('global.not_right_now')"
          :disabled="isLoggingIn"
          @click="close()"
        />
      </div>
    </CDialog>
  </div>
</template>

<script>
import { mapActions } from "vuex";
// import Raven from "raven-js";
// import Settings from "./../../services/Settings";
// import Firebase from "./../../services/Firebase";
import CDialog from "./../Dialog";
import ButtonSignInGoogle from "../specials/ButtonSignInGoogle";
import ButtonSignInTwitter from "../specials/ButtonSignInTwitter";
import ButtonSignInFacebook from "../specials/ButtonSignInFacebook";
import ButtonCointracker from "../specials/ButtonCointracker";
import CButton from "../partials/CButton";

export default {
  name: "SignInDialog",
  components: {
    CDialog,
    ButtonSignInGoogle,
    ButtonSignInTwitter,
    ButtonSignInFacebook,
    CButton,
    ButtonCointracker,
  },
  data() {
    return {
      message: {
        content: "",
        type: "success",
      },
      isLoggingIn: false,
    };
  },
  computed: {
    errorMessage() {
      return this.$store.state.auth.errorMessage;
    },
    loginRequestInProcess() {
      return this.$store.state.auth.loginRequestInProcess;
    },
  },
  methods: {
    close() {
      this.toggleDialog("signIn", false);
    },
    goToEmailRegister() {
      this.close();
      this.$router.push("/register");
    },
    goToEmailLogin() {
      this.close();
      this.$router.push("/login");
    },
    onLoginSuccess() {
      this.close();
      this.$router.push("/");
    },
    signIn(type) {
      this.login({ type }).then(this.onLoginSuccess);
    },
    ...mapActions({
      toggleDialog: "ui/toggleDialog",
      login: "auth/login",
    }),
  },
};
</script>

<style lang="scss" scoped>
.email-row {
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-bottom: 0.5rem;
  margin-right: -0.5rem;

  > * {
    flex: 1 160px;
    margin-right: 0.5rem;
    margin-bottom: 0.5rem;
  }
}
</style>
